/**
 * Global JavaScript
 */

document.addEventListener('DOMContentLoaded', function() {
  
  // Function to close all dropdowns
  function closeAllDropdowns() {
    document.querySelectorAll('.nav-item.dropdown-open').forEach(item => {
      item.classList.remove('dropdown-open');
      const toggle = item.querySelector('.dropdown-toggle');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // Mobile Menu Toggle
  const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
  const headerNav = document.querySelector('.header-nav');
  const headerMenu = document.querySelector('.header-menu');
  
  if (mobileMenuToggle && headerNav) {
    mobileMenuToggle.addEventListener('click', function() {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !isExpanded);
      headerNav.classList.toggle('mobile-open');
      if (headerMenu) {
        headerMenu.classList.toggle('mobile-open');
      }
      
      // Prevent body scroll when menu is open
      if (!isExpanded) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
      
      // Close all dropdowns when closing mobile menu
      if (isExpanded) {
        closeAllDropdowns();
      }
    });
  }

  // Add background to fixed white header on scroll
  if (document.body.classList.contains('has-fixed-white-header')) {
    let lastScroll = 0;
    
    window.addEventListener('scroll', function() {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      
      if (currentScroll > 20) {
        document.body.classList.add('scrolled');
      } else {
        document.body.classList.remove('scrolled');
      }
      
      lastScroll = currentScroll;
    });
  }

  // Dropdown toggles for mobile
  const dropdownToggles = document.querySelectorAll('.dropdown-toggle');
  
  dropdownToggles.forEach(toggle => {
    toggle.addEventListener('click', function(e) {
      // Only handle on mobile
      if (window.innerWidth < 1301) {
        e.preventDefault();
        e.stopPropagation();
        const parent = this.closest('.nav-item');
        const isCurrentlyOpen = parent.classList.contains('dropdown-open');
        
        // Close other open dropdowns first
        document.querySelectorAll('.nav-item.dropdown-open').forEach(item => {
          if (item !== parent) {
            item.classList.remove('dropdown-open');
            const otherToggle = item.querySelector('.dropdown-toggle');
            if (otherToggle) {
              otherToggle.setAttribute('aria-expanded', 'false');
            }
          }
        });
        
        // Toggle current dropdown based on actual class state
        if (isCurrentlyOpen) {
          // Close it
          parent.classList.remove('dropdown-open');
          this.setAttribute('aria-expanded', 'false');
        } else {
          // Open it
          parent.classList.add('dropdown-open');
          this.setAttribute('aria-expanded', 'true');
        }
      }
    });
  });

  // Close dropdown when clicking on dropdown item (mobile only)
  if (window.innerWidth < 1301) {
    document.addEventListener('click', function(e) {
      const dropdownItem = e.target.closest('.dropdown-item');
      if (dropdownItem) {
        // Close the parent dropdown after a short delay to allow navigation
        setTimeout(function() {
          const parentNavItem = dropdownItem.closest('.nav-item');
          if (parentNavItem) {
            parentNavItem.classList.remove('dropdown-open');
            const toggle = parentNavItem.querySelector('.dropdown-toggle');
            if (toggle) {
              toggle.setAttribute('aria-expanded', 'false');
            }
          }
        }, 100);
      }
    });
  }

  // Close mobile menu when clicking outside
  document.addEventListener('click', function(e) {
    if (window.innerWidth < 1301) {
      // Don't close if clicking on dropdown toggle (handled separately)
      if (e.target.closest('.dropdown-toggle')) {
        return;
      }
      
      if (mobileMenuToggle && headerNav && 
          !e.target.closest('.mobile-menu-toggle') && 
          !e.target.closest('.header-nav')) {
        mobileMenuToggle.setAttribute('aria-expanded', 'false');
        headerNav.classList.remove('mobile-open');
        if (headerMenu) {
          headerMenu.classList.remove('mobile-open');
        }
        // Restore body scroll
        document.body.style.overflow = '';
        // Close all dropdowns when closing mobile menu
        closeAllDropdowns();
      }
      
      // Close dropdown if clicking outside of it (but inside mobile menu)
      if (headerNav && headerNav.classList.contains('mobile-open')) {
        if (!e.target.closest('.dropdown-menu') && !e.target.closest('.dropdown-toggle')) {
          const clickedDropdown = e.target.closest('.nav-item.dropdown-open');
          if (!clickedDropdown) {
            closeAllDropdowns();
          }
        }
      }
    }
  });

  // Close mobile menu on window resize
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      if (window.innerWidth >= 1301) {
        if (mobileMenuToggle && headerNav) {
          mobileMenuToggle.setAttribute('aria-expanded', 'false');
          headerNav.classList.remove('mobile-open');
          if (headerMenu) {
            headerMenu.classList.remove('mobile-open');
          }
          // Restore body scroll
          document.body.style.overflow = '';
        }
        
        // Close all dropdowns
        closeAllDropdowns();
      }
    }, 250);
  });

  // Single Post TOC Active Link on Scroll and Smooth Scroll
  const tocLinks = document.querySelectorAll('.single-post__toc-link');
  const headings = document.querySelectorAll('.single-post__entry-content h2[id]');
  
  if (tocLinks.length > 0 && headings.length > 0) {
    // Calculate header offset dynamically
    function getHeaderOffset() {
      const header = document.querySelector('.site-header');
      const topbar = document.querySelector('.global-topbar');
      
      if (!header) {
        return 150; // Fallback offset
      }
      
      // Get header height
      const headerHeight = header.offsetHeight;
      
      // Check if header is fixed
      const headerStyle = window.getComputedStyle(header);
      const isFixed = headerStyle.position === 'fixed' || headerStyle.position === 'sticky';
      
      // Get topbar height if exists
      let topbarHeight = 0;
      if (topbar) {
        topbarHeight = topbar.offsetHeight;
      }
      
      // Calculate total offset
      // If fixed/sticky, add header height + some padding
      // If not fixed, just add some padding for spacing
      if (isFixed) {
        return headerHeight + topbarHeight + 50; // 50px extra padding for better spacing
      } else {
        return headerHeight + 30; // 30px padding for non-fixed
      }
    }
    
    // Smooth scroll functionality when clicking TOC links
    tocLinks.forEach((link) => {
      link.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        if (href && href.startsWith('#')) {
          const targetId = href.substring(1);
          const targetElement = document.getElementById(targetId);
          
          if (targetElement) {
            e.preventDefault();
            
            // Calculate offset dynamically
            const offset = getHeaderOffset();
            const elementPosition = targetElement.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - offset;
            
            // Smooth scroll to target
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
            
            // Update URL without triggering scroll
            if (history.pushState) {
              history.pushState(null, null, href);
            }
          }
        }
      });
    });
    
    function updateActiveTocLink() {
      let current = '';
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      const offset = getHeaderOffset(); // Use dynamic offset
      
      headings.forEach((heading) => {
        const headingTop = heading.getBoundingClientRect().top + scrollPosition - offset;
        const headingBottom = headingTop + heading.offsetHeight;
        
        if (scrollPosition >= headingTop && scrollPosition < headingBottom) {
          current = heading.getAttribute('id');
        }
      });
      
      // If we're past the last heading, make the last link active
      if (!current && headings.length > 0) {
        const lastHeading = headings[headings.length - 1];
        const lastHeadingTop = lastHeading.getBoundingClientRect().top + scrollPosition - getHeaderOffset();
        if (scrollPosition >= lastHeadingTop) {
          current = lastHeading.getAttribute('id');
        }
      }
      
      tocLinks.forEach((link) => {
        const href = link.getAttribute('href');
        if (href === '#' + current) {
          link.classList.add('active');
        } else {
          link.classList.remove('active');
        }
      });
    }
    
    // Update on scroll
    let ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          updateActiveTocLink();
          ticking = false;
        });
        ticking = true;
      }
    });
    
    // Initial update
    updateActiveTocLink();
  }

  // Filter Widget Broker Validation - Replace alert with inline validation
  function initFilterWidgetValidation() {
    // Find broker select field anywhere on page (not just in forms)
    // Try various selectors to find the broker dropdown
    let brokerSelect = document.querySelector('select[name="broker"]') ||
                      document.querySelector('select[name="broker_id"]') ||
                      document.querySelector('select[name="agent"]') ||
                      document.querySelector('select[name="agent_id"]') ||
                      document.querySelector('select[id*="broker"]') ||
                      document.querySelector('select[id*="agent"]') ||
                      document.querySelector('select[id*="Broker"]') ||
                      document.querySelector('select[id*="Agent"]');
    
    // Also check by option text (if placeholder says "Brokeris" or similar)
    if (!brokerSelect) {
      const allSelects = document.querySelectorAll('select');
      allSelects.forEach(select => {
        const firstOption = select.querySelector('option:first-child');
        if (firstOption && (
          firstOption.textContent.toLowerCase().includes('broker') ||
          firstOption.textContent.toLowerCase().includes('brokeris') ||
          firstOption.textContent.toLowerCase().includes('agent')
        )) {
          brokerSelect = select;
        }
      });
    }
    
    if (!brokerSelect) return;
    
    // Skip if already initialized
    if (brokerSelect.dataset.brokerValidationInitialized === 'true') {
      return;
    }
    
    // Mark as initialized
    brokerSelect.dataset.brokerValidationInitialized = 'true';
    
    // Find the form (could be parent or nearby)
    let form = brokerSelect.closest('form');
    if (!form) {
      // Try to find form by looking for submit button nearby
      const widget = brokerSelect.closest('.lt-re-filter-widget, [class*="filter"]');
      if (widget) {
        const allButtons = widget.querySelectorAll('button, input[type="submit"]');
        for (let btn of allButtons) {
          const btnText = btn.textContent || btn.value || '';
          if (btnText.includes('RODYTI') || btnText.includes('Rezultat') || btn.type === 'submit') {
            form = btn.closest('form') || widget;
            break;
          }
        }
      }
    }
    
    // Find the best place to insert error message (after select, not inside)
    let errorContainer = brokerSelect.parentElement;
    
    // If Select2 is used, find the container
    if (typeof jQuery !== 'undefined' && jQuery.fn.select2) {
      const select2Container = jQuery(brokerSelect).closest('.select2-container').parent();
      if (select2Container.length) {
        errorContainer = select2Container[0];
      }
    }
    
    // Ensure error container has position relative for absolute positioning
    if (getComputedStyle(errorContainer).position === 'static') {
      errorContainer.style.position = 'relative';
    }
    
    // Find existing error element (from HTML) or create one
    let errorElement = document.getElementById('broker-error') ||
                       brokerSelect.closest('.lt-re-filter-field-wrapper')?.querySelector('.filter-widget-error') ||
                       brokerSelect.parentElement.querySelector('.filter-widget-error');
    if (!errorElement) {
      errorElement = document.createElement('span');
      errorElement.className = 'filter-widget-error';
      // Insert after select (or its Select2 container)
      const wrapper = brokerSelect.closest('.lt-re-filter-field-wrapper') || brokerSelect.parentElement;
      wrapper.appendChild(errorElement);
    }
    
    // Add wrapper class for styling
    if (!errorContainer.classList.contains('filter-widget-field-wrapper')) {
      errorContainer.classList.add('filter-widget-field-wrapper');
    }
    
    // Handle Select2 if present
    let select2Instance = null;
    if (typeof jQuery !== 'undefined' && jQuery.fn.select2) {
      select2Instance = jQuery(brokerSelect).data('select2');
    }
    
    // Function to validate and show error
    function validateBroker() {
      // Only validate if brokeris tab is active
      const activeTab = document.querySelector('.lt-re-filter-widget .lt-re-filter-tab.active');
      if (activeTab && activeTab.dataset.tab !== 'brokeris') {
        // Not on broker tab, skip validation
        return true;
      }

      const brokerValue = brokerSelect.value ? brokerSelect.value.trim() : '';

      // Check if broker is required and not selected
      if (!brokerValue || brokerValue === '' || brokerValue === '0') {
        // Show inline error - force red border with !important
        brokerSelect.classList.add('filter-widget-error-field');
        brokerSelect.style.setProperty('border-color', '#C02324', 'important');
        brokerSelect.style.setProperty('border-width', '2px', 'important');
        brokerSelect.style.setProperty('border-style', 'solid', 'important');
        brokerSelect.style.setProperty('border', '2px solid #C02324', 'important');
        
        if (select2Instance) {
          const select2Container = jQuery(brokerSelect).closest('.select2-container');
          select2Container.addClass('filter-widget-error-field');
          select2Container.find('.select2-selection--single').css({
            'border-color': '#C02324 !important',
            'border-width': '2px !important',
            'border-style': 'solid !important',
            'border': '2px solid #C02324 !important'
          });
        }
        errorElement.textContent = 'Pasirinkite brokerį';
        errorElement.style.cssText = 'display: block !important; color: #C02324 !important; margin-top: 8px !important; margin-bottom: 8px !important; font-size: 12px !important; font-weight: 500 !important; line-height: 130% !important; font-family: "DM Sans", sans-serif !important; width: 100% !important;';
        
        // Scroll to error
        const scrollTarget = select2Instance ? 
          jQuery(brokerSelect).closest('.select2-container')[0] : 
          brokerSelect;
        scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
        
        // Focus the select
        if (select2Instance) {
          setTimeout(() => jQuery(brokerSelect).select2('open'), 100);
        } else {
          brokerSelect.focus();
        }
        
        return false;
      } else {
        // Clear error if broker is selected
        brokerSelect.classList.remove('filter-widget-error-field');
        brokerSelect.style.borderColor = '';
        brokerSelect.style.borderWidth = '';
        brokerSelect.style.borderStyle = '';
        
        if (select2Instance) {
          const select2Container = jQuery(brokerSelect).closest('.select2-container');
          select2Container.removeClass('filter-widget-error-field');
          select2Container.find('.select2-selection--single').css({
            'border-color': '',
            'border-width': '',
            'border-style': ''
          });
        }
        errorElement.style.display = 'none';
        return true;
      }
    }
    
    // Handle form submission
    if (form) {
      form.addEventListener('submit', function(e) {
        if (!validateBroker()) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      }, true); // Use capture phase to catch early
    }
    
    // Also handle button clicks (in case form submit is not used)
    const allButtons = document.querySelectorAll('button, input[type="submit"]');
    allButtons.forEach(button => {
      const buttonText = button.textContent || button.value || '';
      // Check if button is a submit button (contains "RODYTI" or "Rezultat" or is submit type)
      if (buttonText.includes('RODYTI') || buttonText.includes('Rezultat') || button.type === 'submit') {
        // Check if button is near the broker select
        const widget = brokerSelect.closest('.lt-re-filter-widget, [class*="filter"]');
        if (widget && widget.contains(button)) {
          button.addEventListener('click', function(e) {
            if (!validateBroker()) {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              return false;
            }
          }, true); // Use capture phase
        }
      }
    });
    
    // Also use event delegation for dynamically added buttons - more aggressive
    document.addEventListener('click', function(e) {
      const target = e.target;
      const targetText = target.textContent || target.value || '';
      
      // Check if clicked button is a submit button
      if ((target.tagName === 'BUTTON' || (target.tagName === 'INPUT' && target.type === 'submit')) &&
          (targetText.includes('RODYTI') || targetText.includes('Rezultat') || target.type === 'submit')) {
        
        // Check if broker select exists and is empty
        const currentBrokerValue = brokerSelect.value ? brokerSelect.value.trim() : '';
        if (!currentBrokerValue || currentBrokerValue === '' || currentBrokerValue === '0') {
          // Check if button is in the same widget area as broker select
          const widget = brokerSelect.closest('.lt-re-filter-widget, [class*="filter"], [id*="filter"]');
          const buttonWidget = target.closest('.lt-re-filter-widget, [class*="filter"], [id*="filter"]');
          
          // If they're in the same widget or nearby, validate
          if (widget && (widget.contains(target) || buttonWidget === widget || 
              document.querySelector('.lt-re-filter-widget, [class*="filter"]')?.contains(target))) {
            if (!validateBroker()) {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              return false;
            }
          }
        }
      }
    }, true); // Use capture phase to catch early
    
    // Clear error on change
    brokerSelect.addEventListener('change', function() {
      if (this.value && this.value.trim() !== '' && this.value !== '0') {
        this.classList.remove('filter-widget-error-field');
        this.style.borderColor = '';
        this.style.borderWidth = '';
        this.style.borderStyle = '';
        
        if (select2Instance) {
          const select2Container = jQuery(this).closest('.select2-container');
          select2Container.removeClass('filter-widget-error-field');
          select2Container.find('.select2-selection--single').css({
            'border-color': '',
            'border-width': '',
            'border-style': ''
          });
        }
        errorElement.style.display = 'none';
      }
    });
    
    // Clear error on focus
    brokerSelect.addEventListener('focus', function() {
      this.classList.remove('filter-widget-error-field');
      this.style.borderColor = '';
      this.style.borderWidth = '';
      this.style.borderStyle = '';
      
      if (select2Instance) {
        const select2Container = jQuery(this).closest('.select2-container');
        select2Container.removeClass('filter-widget-error-field');
        select2Container.find('.select2-selection--single').css({
          'border-color': '',
          'border-width': '',
          'border-style': ''
        });
      }
      errorElement.style.display = 'none';
    });
    
    // Also handle Select2 change event if present
    if (select2Instance && typeof jQuery !== 'undefined') {
      jQuery(brokerSelect).on('select2:select select2:clear', function() {
          const value = jQuery(this).val();
          if (value && value !== '' && value !== '0') {
            brokerSelect.classList.remove('filter-widget-error-field');
            brokerSelect.style.borderColor = '';
            brokerSelect.style.borderWidth = '';
            brokerSelect.style.borderStyle = '';
            
            const select2Container = jQuery(brokerSelect).closest('.select2-container');
            select2Container.removeClass('filter-widget-error-field');
            select2Container.find('.select2-selection--single').css({
              'border-color': '',
              'border-width': '',
              'border-style': ''
            });
            errorElement.style.display = 'none';
          }
      });
    }
  }
  
  // Override alert to prevent broker validation alerts
  const originalAlert = window.alert;
  window.alert = function(message) {
    // If message is about broker selection, don't show alert (we handle it inline)
    if (message && (
      message.toLowerCase().includes('broker') ||
      message.toLowerCase().includes('brokeris') ||
      message.toLowerCase().includes('pasirinkite broker')
    )) {
      // Find the form and trigger our validation instead
      const forms = document.querySelectorAll('form');
      forms.forEach(form => {
        const brokerSelect = form.querySelector('select[name="broker"], select[name="broker_id"], select[name="agent"], select[name="agent_id"]');
        if (brokerSelect) {
          const event = new Event('submit', { bubbles: true, cancelable: true });
          form.dispatchEvent(event);
        }
      });
      return; // Don't show alert
    }
    // For other alerts, show normally
    return originalAlert.apply(window, arguments);
  };
  
  // Initialize on DOM ready
  initFilterWidgetValidation();
  
  // Also initialize after a short delay to catch dynamically loaded content
  setTimeout(initFilterWidgetValidation, 500);
  setTimeout(initFilterWidgetValidation, 1000);
  
  // Re-initialize after AJAX content loads (for dynamically loaded widgets)
  if (typeof jQuery !== 'undefined') {
    jQuery(document).ajaxComplete(function() {
      setTimeout(initFilterWidgetValidation, 100);
    });
    
    // Also intercept jQuery click events on submit buttons
    jQuery(document).on('click', 'button, input[type="submit"]', function(e) {
      const button = this;
      const buttonText = jQuery(button).text() || jQuery(button).val() || '';
      
      if (buttonText.includes('RODYTI') || buttonText.includes('Rezultat') || button.type === 'submit') {
        const brokerSelect = jQuery('select[name="broker"], select[name="broker_id"], select[name="agent"], select[name="agent_id"]').first();
        
        if (brokerSelect.length) {
          const brokerValue = brokerSelect.val() ? String(brokerSelect.val()).trim() : '';
          
          if (!brokerValue || brokerValue === '' || brokerValue === '0') {
            // Show error - force red border with !important
            brokerSelect.addClass('filter-widget-error-field');
            brokerSelect.css({
              'border-color': '#C02324 !important',
              'border-width': '2px !important',
              'border-style': 'solid !important',
              'border': '2px solid #C02324 !important'
            });
            
            const select2Container = brokerSelect.closest('.select2-container');
            select2Container.addClass('filter-widget-error-field');
            select2Container.find('.select2-selection--single').css({
              'border-color': '#C02324 !important',
              'border-width': '2px !important',
              'border-style': 'solid !important',
              'border': '2px solid #C02324 !important',
              'box-shadow': '0 0 0 3px rgba(192, 35, 36, 0.1) !important'
            });
            
            // Find or create error element
            let errorContainer = brokerSelect.parent();
            if (select2Container.length) {
              errorContainer = select2Container.parent();
            }
            
            // Ensure container has position relative
            if (errorContainer.css('position') === 'static') {
              errorContainer.css('position', 'relative');
            }
            
            let errorElement = errorContainer.find('.filter-widget-error');
            if (!errorElement.length) {
              errorElement = jQuery('<span class="filter-widget-error body-3-medium" style="position: absolute !important; top: 100% !important; left: 0 !important; display: block !important; color: #C02324 !important; margin-top: 8px !important; font-size: 12px !important; font-weight: 500 !important; line-height: 130% !important; font-family: \'DM Sans\', sans-serif !important; visibility: visible !important; opacity: 1 !important; z-index: 10 !important; white-space: nowrap !important;">Pasirinkite brokerį</span>');
              if (select2Container.length && select2Container[0].nextSibling) {
                errorContainer[0].insertBefore(errorElement[0], select2Container[0].nextSibling);
              } else {
                errorContainer.append(errorElement);
              }
            } else {
              errorElement.text('Pasirinkite brokerį').css({
                'position': 'absolute',
                'top': '100%',
                'left': '0',
                'display': 'block',
                'color': '#C02324',
                'visibility': 'visible',
                'opacity': '1',
                'z-index': '10',
                'white-space': 'nowrap'
              }).show();
            }
            
            // Scroll to error
            brokerSelect[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
            
            // Open select2 if present
            if (jQuery.fn.select2 && brokerSelect.data('select2')) {
              brokerSelect.select2('open');
            }
            
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return false;
          }
        }
      }
    });
  }
  
  // Also check periodically for dynamically added widgets
  const observer = new MutationObserver(function(mutations) {
    initFilterWidgetValidation();
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});
